<script lang="ts" setup>
import { TSelectOption } from "@profeat/ui-kit/dist/components/PSelect/types";
import { IconErrorMd as ErrorIcon } from "@profeat/ui-kit";

defineProps<{
  selectOptions: TSelectOption[];
}>();

const emit = defineEmits<{
  valueChanged: [TSelectOption];
}>();
</script>
<template>
  <div class="option-selector">
    <ul>
      <li
        v-for="item in selectOptions"
        :key="String(item.value)"
        class="list-item"
        @click="emit('valueChanged', item)"
      >
        <ErrorIcon v-if="item.warn" />
        {{ item.text }}
      </li>
    </ul>
  </div>
</template>
<style lang="scss" scoped>
.option-selector {
  max-height: 400px;
}
.list-item {
  font-size: 14px;
  height: 30px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.list-item:hover {
  background-color: #eee;
}
</style>
